import { selectBlackFridayPhase } from '@app/blackfriday';
import { createSelector } from 'reselect';
import type { UIState } from './types';

export const getUi = ({ ui = {} as UIState }: { ui: UIState }) => ui;

export const getIsMobileNavOpen = createSelector(
  getUi,
  ({ isMobileNavOpen = false }) => isMobileNavOpen,
);

export const getShowWhereAreYouModal = createSelector(
  getUi,
  ({ showWhereAreYouModal }) => showWhereAreYouModal,
);

export const getBanners = createSelector(getUi, (ui) => ui.banners);

export const getOnBanners = createSelector(getBanners, (banners) => {
  if (!banners) {
    return [];
  }

  return Object.keys(banners).filter((name) => banners[name] === true);
});

export const getVisibleBanners = createSelector(getOnBanners, (openBanners) => {
  const priorityBanners = ['vacationMode', 'shipBy', 'hyperwallet'];

  const blackFridayPhase = selectBlackFridayPhase();

  if (blackFridayPhase) {
    priorityBanners.push('blackFriday');
  }

  const hyperwalletPriorityBanners = ['vacationMode', 'shipBy', 'hyperwallet'];
  const topPriorityBanners = openBanners.filter((name) =>
    priorityBanners.includes(name),
  );

  // sets priority for which banners should show over others
  if (topPriorityBanners.length === 4) {
    return hyperwalletPriorityBanners;
  }

  if (topPriorityBanners.length) {
    return topPriorityBanners;
  }

  return [];
});

export const getIsBannerVisible = (state, bannerName) => {
  const visibleBanners = getVisibleBanners(state);
  return visibleBanners.includes(bannerName);
};

export const getNavbarHeight = createSelector(
  getUi,
  ({ navbarHeight }) => navbarHeight,
);
